module.exports = __webpack_public_path__ + "static/img/icon4.e014442e.svg";